import React from "react";
import { AutoComplete } from "antd";
import {CharLimit as charLimit} from "../../../constant/constants";

function CategoryNameInput({
  mode,
  isInitialEditMode,
  categoryName,
  options,
  onSearch,
  onSelect,
  onClear,
}) {
  return (
    <div className="mt-6">
      <div className="mb-[3px] font-ubold">Name <span className="text-red-600">*</span></div>
      {isInitialEditMode ? (
        <div>{categoryName}</div> // Show static text if in initial edit mode
      ) : (
        <AutoComplete
          value={categoryName}
          options={options}
          onSearch={(value) => {
            const trimmed = value.slice(0, charLimit.Name);
            onSearch(trimmed);
            if (!trimmed) {
              onClear();
            }
          }}
          onChange={(value) => {
            if (!Boolean(value)) return;
            const trimmed = value.slice(0, charLimit.Name);
            onSearch(trimmed);
            if (!trimmed) {
              onClear();
            }
          }}
          onSelect={onSelect} // Fetch details when an item is selected
          placeholder="Type or select a category"
          className="w-full mb-2"
          allowClear
          onClear={onClear}
        />
      )}
      <div className="mt-1 text-[12px] text-gray-600 italic mb-2">
        Char limit 100 ({categoryName.length})
      </div>
    </div>
  );
}

export default CategoryNameInput;
